export const Images = {
  HEADER_BG_IMAGE: require("./images/background2.webp"),
  ROUNDED_TITLE: require("./images/rounded-title.svg").default,

  DRINK_ICON: require("./images/icons/drink.svg").default,
  ICE_CREAM_ICON: require("./images/icons/ice-cream.svg").default,
  PIZZA_ICON: require("./images/icons/pizza-slice.svg").default,

  NOODLES: require("./images/pates.webp"),
  PUDDING: require("./images/tiramisu.webp"),
  SUSHE: require("./images/tomates.webp"),

  PIZZA: require("./images/Pizza.webp"),
  LOCATION: require("./images/icons/location.svg").default,
  UBER_EATS: require("./images/uber-eats.png"),
  JUST_EAT: require("./images/just-eat.png"),
  TOP_10: require("./images/top-10.svg").default,

  CONTACT: require("./images/contact.svg").default,

  INSTAGRAM_ICON: require("./images/icons/instagram.svg").default,
  FACEBOOK_ICON: require("./images/icons/facebook.svg").default,
  LINKEDIN_ICON: require("./images/icons/linkedin.svg").default,

  MAIN_LOGO: require("./images/logo/logo.png"),
  BG_MAIN_LOGO: require("./images/logo/bg-logo.png"),

  HOME: require("./icons/home.svg").default,
  MENU: require("./icons/menu.svg").default,
  ABOUT: require("./icons/about.svg").default,
  CONTACT: require("./icons/contact.svg").default,
  DELIVERY: require("./icons/delivery.svg").default,

  COORDINATES_SECTION_IMAGE: require("./images/coordinates-img.svg").default,
};
